import { Reels } from "@wix/wix-ui-icons-common";
import { Node_Type } from "./../ricos-types/index.js";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common/index.js";
import { gifModals } from "./constants.js";
import { INSERT_GIF_BUTTON } from "./data-hooks.js";
import { GiphyInsertModal } from "./modals/InsertModal.js";
const toolbarsToAddIn = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE
];
const getAddButtons = (config, services) => {
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    {
      id: Node_Type.GIF,
      label: INSERT_PLUGIN_BUTTONS.GIF,
      dataHook: INSERT_GIF_BUTTON,
      icon: Reels,
      tooltip: "GiphyPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ referenceElement }) => {
        modals?.togglePluginPanel({
          id: gifModals.insert,
          Component: GiphyInsertModal,
          componentProps: {
            modalId: gifModals.insert,
            getGiphyUrl: config?.getGiphyUrl
          },
          isMobile,
          positioning: {
            referenceElement,
            placement: "bottom"
          }
        });
        return true;
      },
      menuConfig: {
        tags: "Gif_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
